import { filterOutNullable } from '@gitbook/util-ts';

import type { OrderedSetDiff } from './diffOrderedSets';

export type PatchValue =
    | {
          key: string;
          op: '+';
          /** If true, the insertion was caused by a move from another index in the set */
          move?: true;
      }
    | {
          key: string;
          op: '-';
          /** If true, the deletion was caused by a move at another index in the set */
          move?: true;
      }
    | {
          key: string;
          op: '=';
      };

/**
 * Apply the diff generated by `diffOrderedSets` to the ancestor array creating an array of metadata.
 */
export function patchOrderedSet(before: string[], diff: OrderedSetDiff[]): Array<PatchValue> {
    const result: Array<Array<null | PatchValue>> = before.map((each) => {
        return [{ key: each, op: '=' }];
    });
    const prefix: Array<PatchValue> = [];
    const insertValue = (key: string, index: number, move?: boolean) => {
        index === -1
            ? prefix.push({ key, op: '+', ...(move ? { move } : {}) })
            : result[index]?.push({ key, op: '+', ...(move ? { move } : {}) });
    };

    diff.forEach((each) => {
        const newIndex = each[0];
        const updates = each[1];
        updates.forEach(({ insert, move }) => {
            if (insert !== undefined) {
                if (newIndex == null) {
                    throw new Error('Cannot insert at null index');
                }
                insertValue(insert, newIndex);
            } else {
                if (newIndex == null) {
                    // @ts-expect-error
                    result[move][0] = { ...result[move][0], op: '-' };
                } else {
                    // @ts-ignore
                    insertValue(before[move], newIndex, true);
                    // @ts-expect-error
                    result[move][0] = { key: result[move][0].key, op: '-', move: true };
                }
            }
        });
    });
    return prefix.concat(result.flat().filter(filterOutNullable));
}
